/* eslint-disable no-unused-vars */
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Reusable Components
import MKTypography from "components/MKTypography";
import MKBadge from "components/MKBadge";
import TransparentBlogCard from "reusables/Cards/BlogCards/TransparentBlogCard";
import BackgroundBlogCard from "reusables/Cards/BlogCards/BackgroundBlogCard";
import SubTitleContents from "reusables/TextFormats/SubTitleContents";

// Images
import regular1 from "assets/images/Services/Office/regular1.jpg";
import regular2 from "assets/images/Services/Office/regular2.jpg";
import regular3 from "assets/images/Services/Office/regular3.jpg";
import regular4 from "assets/images/Services/Office/regular4.jpg";
import regular5 from "assets/images/Services/Office/regular5.jpg";
import regular6 from "assets/images/Services/Office/regular6.jpg";

function Office_Section1() {
  return (
    <Container>
      <SubTitleContents title="Regular Cleaning Plans" contents="" />
      {/* <Grid container item xs={12} lg={6}>
        <MKTypography variant="h3" mb={3}>
          Regular Cleaning Plans
        </MKTypography>
      </Grid> */}
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} lg={4} textAlign="justify" wordbreak="break-all">
          <TransparentBlogCard
            image={regular3}
            title="Daily Cleaning"
            description="Maintain a spotless and hygienic office environment every day with our daily cleaning service. Perfect for busy workplaces, it ensures your office is always professional, welcoming, and ready for business."
            action={{
              type: "internal",
              route: "/",
              color: "info",
              // label: "read more",
            }}
            popular={true}
          />
        </Grid>
        <Grid item xs={12} sm={6} lg={4} textAlign="justify" wordbreak="break-all">
          <TransparentBlogCard
            image={regular6}
            title="Weekly Cleaning"
            description="Ideal for offices with moderate foot traffic, our weekly cleaning service helps maintain a tidy and professional workspace. A practical solution for keeping your office clean and organized throughout the week."
            action={{
              type: "internal",
              route: "/",
              color: "info",
              // label: "read more",
            }}
            // popular={false}
          />
        </Grid>
        <Grid item xs={12} lg={4}>
          <BackgroundBlogCard
            image={regular5}
            title="Tailored Cleaning Plans"
            description="Customized cleaning schedules designed to fit your unique needs and lifestyle-flexible, reliable, and just the way you like it"
            // action={{
            //   type: "internal",
            //   route: "/",
            //   label: "read more",
            // }}
            // popular={false}
          />
        </Grid>
      </Grid>
    </Container>
  );
}

export default Office_Section1;
